import React from 'react'
import './Header.css'


function Header() {
    return (
        <div className="main">
            <h1>The Poll Booth</h1>
        </div>
    )
}

export default Header
